/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinknone2Inputs */

const en_profilelinknone2 = /** @type {(inputs: Profilelinknone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No profile connected yet.`)
};

const de_profilelinknone2 = /** @type {(inputs: Profilelinknone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Profil verbunden.`)
};

/**
* | output |
* | --- |
* | "No profile connected yet." |
*
* @param {Profilelinknone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinknone2 = /** @type {((inputs?: Profilelinknone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinknone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinknone2(inputs)
	return de_profilelinknone2(inputs)
});
export { profilelinknone2 as "profileLinkNone" }